import React from "react";

export default function ChevronDownIcon({ id }) {
    return <svg id={id} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.9201 8.9502L13.4001 15.4702C12.6301 16.2402 11.3701 16.2402 10.6001 15.4702L4.08008 8.9502" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/chevronDownIcon.jsx